import type { MutableRefObject } from 'react';
import { useState, useEffect, memo } from 'react';
import { useTracking } from 'react-tracking';
import useUser from '@/hooks/useUser';
import loadable from '@loadable/component';
import { FastCommentsWidget } from '@/components/FastCommentWidget';
import { PUBLIC_SWS_ENV } from '@/constants/env';

const GuestRegistrationModal = loadable(
  () => import('@components/GuestRegistrationModal'),
  {
    ssr: false,
  }
);

const FastComments = memo(FastCommentsWidget);

const getFastCommentsCanonicalUrl = (canonicalURL: string) => {
  return PUBLIC_SWS_ENV === 'prod'
    ? `https://simplywall.st${canonicalURL}`
    : canonicalURL;
};

interface ArticleCommentProps {
  scrollCommentRef: MutableRefObject<HTMLDivElement | null>;
  canonicalURL: string;
}

const ArticleComment = ({
  canonicalURL,
  scrollCommentRef,
}: ArticleCommentProps) => {
  const { data: userData } = useUser();
  const { trackEvent } = useTracking({
    type: 'track',
    subject: 'newsComments',
  });
  const [showRegModal, setShowRegModal] = useState(false);

  useEffect(() => {
    if (window.location.href.includes('#comments')) {
      if (scrollCommentRef?.current) {
        scrollCommentRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [scrollCommentRef]);

  return (
    <>
      {showRegModal && (
        <GuestRegistrationModal
          canClose={true}
          onClose={() => {
            trackEvent({
              action: 'click',
              modifier: 'cancelRegistration',
            });
            setShowRegModal(false);
          }}
          onRegisterSuccess={() => {
            trackEvent({
              action: 'success',
              modifier: 'registration',
            });
          }}
        />
      )}
      <section ref={scrollCommentRef}>
        <FastComments
          urlId={getFastCommentsCanonicalUrl(canonicalURL)}
          userData={userData}
          setShowRegModal={setShowRegModal}
        />
      </section>
    </>
  );
};

export default ArticleComment;
